<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="4 0 20 24"
    width="26"
    height="32"
    fill="none"
  >
    <path
      d="M14,2H6C4.9,2,4,2.9,4,4v16c0,1.1,0.9,2,2,2h12c1.1,0,2-0.9,2-2V8L14,2z M7.6,17.2l1.5-2c0.2-0.267,0.6-0.267,0.8,0 l1.1,1.467l2.1-2.8c0.2-0.267,0.6-0.267,0.8,0l2.5,3.333c0.247,0.33,0.012,0.8-0.4,0.8H8C7.588,18,7.353,17.53,7.6,17.2z M13,9V3.5 L18.5,9H13z"
      fill="currentcolor"
    />
  </svg>
</template>
